import { Box, Typography } from "@mui/material";
import { getImportData, importClients } from "api/services/clients/clients";
import DrawerWrapper from "components/DrawerWrapper";
import FileDrop from "components/FileDrop";
import LoadingButton from "components/LoadingButton";
import { snack } from "components/toast";
import { useState } from "react";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { DialogProps, ResType } from "types";
import { FILETYPES } from "data/constants";
import Modal from "@mui/material/Modal";
import Button from "@mui/material/Button";
import { exportErrorList } from "api/services/reports";
import Loader from "components/Loader";

interface Props extends DialogProps {
  successCb?: () => void;
}

function ImportClients({ open, setOpen }: Props) {
    const queryClient = useQueryClient();
  const [file, setFile] = useState<File | null>(null);
  const [openModal, setOpenModal] = useState(false);
  const [importStatus, setImportStatus] = useState<boolean>(false);
  const handleOpen = () => setOpenModal(true);
  const handleClose = () => {
    setOpenModal(!openModal);
  };
  let [errorsListModal, setErrorsListModal]: any = useState([]);

  const { mutate, isLoading } = useMutation(importClients, {
    onSuccess: (e: any) => {
      snack.success(e.data.message);
      setOpen(false);
      setFile(null);
      setTimeout(() => {
      queryClient.invalidateQueries("import-data");        
      }, 200);
    },
    onError: (err: any) => {
      snack.error(err.response.data.message);
    },
  });

  const { isLoading: isImportLoading }: ResType = useQuery(
    ["import-data"],
    getImportData,
    {
      enabled: open,
      onSuccess: (res: any) => {
        const importStatus = res?.data?.[0]?.status === "PENDING";
        setImportStatus(importStatus);
      },
    }
  );
  const { mutate: getErrorFile, isLoading: loading } = useMutation(exportErrorList, {
    onSuccess: (res: any) => {
      const arr = new Uint8Array(res.data?.data);
      const blob = new Blob([arr], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const file = window.URL.createObjectURL(blob);
      let link = document.createElement("a");
      link.href = file;
      link.download = "Clients Import Errors.xlsx";
      link.click();
      snack.success("Exported successfully");
    },
    onError: (err: any) => {
      snack.error(err.response.data.message);
    },
  });

  const handleExport = () => {
    getErrorFile(errorsListModal);
  };

  const handleFiles = (files: File[]) => {
    setFile(files[0]);
  };

  const handleSubmit = () => {
    if (!file) {
      snack.error("Select a file");
      return;
    }

    const ValidFile = (): boolean => {
      return (
        file.type === FILETYPES.SHEET1 ||
        file.type === FILETYPES.SHEET2 ||
        file.type === FILETYPES.SHEET3
      );
    };

    if (!ValidFile()) {
      snack.error("Invalid File Type, Only .xls or .xlsx files are accepted");
      return;
    }

    let formData = new FormData();
    formData.append("file", file);
    mutate(formData);
  };

  const style = {
    position: "absolute" as "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  };

  if (isImportLoading) {
    return <Loader />;
  }
  
  return (
    <DrawerWrapper open={open} setOpen={setOpen} title="Import Clients">
      <FileDrop onChange={handleFiles} />
      <Box display="flex" justifyContent="space-between">
        <Typography variant="caption" color="rgba(0,0,0,0.7)">
          *Only .xls or .xlsx files are accepted
        </Typography>
        <a
          style={{ textDecoration: "none" }}
          // href="https://vider-prod-bucket.s3.ap-south-1.amazonaws.com/ATOM%2BClients%2BBulkImport%2BSheet+(1).xlsx"
          // href="https://vider-prod-bucket.s3.ap-south-1.amazonaws.com/ATOM%2B-%2BClients%2BBulkImportProd.xlsx"
          href="https://vider-prod-bucket.s3.ap-south-1.amazonaws.com/ATOM%2BClients%2BBulkImport%2BSheet-Vider.xlsx"
        >
          <Typography variant="caption" color="secondary">
            Download Sample File
          </Typography>
        </a>
      </Box>
      <LoadingButton
        onClick={handleSubmit}
        variant="contained"
        disabled={importStatus || isLoading}
        loading={importStatus || isLoading}
        sx={{ mt: 3 }}
        fullWidth
        color="secondary"
        title="Import Clients"
      />
      {(importStatus || isLoading)  && <Typography sx={{ m:2, color: "#f44336" }} variant="h6" >Clients are importing, you can't import again now.</Typography>}
      {isLoading ? (
        <Modal
          open={isLoading}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box
            sx={{
              ...style,
              zIndex: "100",
              height: "30vh",
              width: "60vw",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignContent: "center",
              overflow: "auto",
            }}
          >
            <Typography textAlign={"center"} variant="h6">Creating Clients</Typography>
            <Typography textAlign={"center"} sx={{ marginTop: "8px" }}>
              Thanks for your patience! We're currently importing a large number of new clients.
              This may take a few minutes. Please wait while the import completes and avoid
              refreshing the page to prevent errors.
            </Typography>
            <Loader minHeight={"70px"} />
          </Box>
        </Modal>
      ) : null}
    </DrawerWrapper>
  );
}

export default ImportClients;
